<template>
  <vx-tooltip :text="isLoggedIn ? $t('logout') : $t('login')" position="bottom">
    <vs-button
      id="ctiLoginButton"
      color="success"
      :type="isLoggedIn ? 'filled' : 'border'"
      icon-pack="feather"
      :icon="isLoggedIn ? 'icon-log-out' : 'icon-log-in'"
      @click="isLoggedIn ? logout() : login()">
    </vs-button>
  </vx-tooltip>
</template>

<script>
export default {
  name: 'CtiLogin',
  props: {
    servers: {
      required: true
    },
    socket: {
      required: true
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    extension () {
      return this.$store.getters.extension
    },
    isCtiLoading () {
      return this.$store.getters.isCtiLoading
    }
  },
  methods: {
    async login () {
      if (this.extension === null || this.extension.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'User does not have a valid Extension Number.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      this.$vs.loading({background: '#fff', color: 'success', container: '#ctiLoginButton', scale: 0.35, type: 'sound'})

      try {

        await this.$store.dispatch('ctiProcess', { id: 'register', url: false, option: 1, domain: this.servers.domain })
        await this.$store.dispatch('ctiLoading', { socket: this.socket, domain: this.servers.domain })

        this.$emit('listenToIncomingCalls')

        this.$vs.notify({
          title:'CTI Notice',
          text:'Logged In Successfully.',
          color:'success',
          position:'top-right'
        })

      } catch (e) {

        this.$vs.notify({
          title:'CTI Notice',
          text:e.message,
          color:'danger',
          position:'top-right'
        })

      }

      this.$vs.loading.close('#ctiLoginButton > .con-vs-loading')
    },
    async logout () {
      this.$vs.loading({background: '#fff', color: 'success', container: '#ctiLoginButton', scale: 0.35, type: 'sound'})

      try {

        await this.$store.dispatch('ctiProcess', { id: 'unregister', url: false, option: 1, domain: this.servers.domain })
        await this.$store.dispatch('ctiLoading', { socket: this.socket, domain: this.servers.domain }) // TODO: Remove this, or handle clear interval from here.
        await this.$store.dispatch('updateIsLoggedIn', false)

        this.$emit('disconnectToIncomingCalls')

        this.$vs.notify({
          title:'CTI Notice',
          text:'Logged Out Successfully.',
          color:'success',
          position:'top-right'
        })

      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:e.message,
          color:'danger',
          position:'top-right'
        })
      }

      this.$vs.loading.close('#ctiLoginButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#ctiLoginButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
